import { render } from "./ContractDetails.vue?vue&type=template&id=1ddb3082&scoped=true"
import script from "./ContractDetails.vue?vue&type=script&lang=js"
export * from "./ContractDetails.vue?vue&type=script&lang=js"

import "./ContractDetails.vue?vue&type=style&index=0&id=1ddb3082&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddb3082"]])

export default __exports__